import { useAnalytics } from "~/contexts/analytics-context";
import { useProduct } from "~/contexts/product-context";
import { DatabaseBisacCodes } from "./database-bisac-codes";
import { FinalBisacCodes } from "./final-bisac-codes";
import { useBisacSubjects } from "./use-bisac-subjects";

export const BisacTab = () => {
  const { product } = useProduct();
  const { gaEvent } = useAnalytics();
  const {
    databaseSubjects,
    finalSubjects,
    isFinal,
    addCodes,
    addSubject,
    removeSubject,
    reorder,
  } = useBisacSubjects();

  if (!product) return null;

  return (
    <div className="flex items-start gap-4 h-full">
      <DatabaseBisacCodes
        subjects={databaseSubjects}
        isFinal={isFinal}
        onAdd={addSubject}
        onRemove={removeSubject}
      />
      <FinalBisacCodes
        subjects={finalSubjects}
        onOpenModal={() =>
          gaEvent({
            type: "open_bisac_search_modal",
            payload: { book: product.id },
          })
        }
        onCopy={(codesCount) =>
          gaEvent({
            type: "copy_final_bisac_codes",
            payload: { book: product.id, codes_count: codesCount },
          })
        }
        onAdd={addCodes}
        onRemove={removeSubject}
        onReorder={reorder}
      />
    </div>
  );
};
